import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f2f4238"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Eliminar CarNatur", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esta acción no se puede deshacer.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { Ref, ref } from 'vue'
import axios from 'axios';
import { UrlGlobal } from '@/store/dominioGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'DlLogUbica',
  props: {
    btnLuDl: Boolean,
    almacen: String,
    area: String,
    anaquel: String,
    cara: String,
    fila: String,
    columna: String,

},
  emits: ['delLuProps'],
  setup(__props, { emit: __emit }) {

const dUrl = UrlGlobal()
//props y emits ----------------------------------------------------------------
const props = __props
const emits = __emit
const handleClick = () => {
    emits("delLuProps", !props.btnLuDl)
}
//----------------------------------------------------------------

// variable para el parametro o filtro para eliminar---------------------------
let almacen = ref(props.almacen)
let area = ref(props.area)
let anaquel = ref(props.anaquel)
let cara = ref(props.cara)
let fila = ref(props.fila)
let columna = ref(props.columna)


// función para eliminar el registro---------------------------------------------
const handleSubmit = async () => {
    try {
        const response = await axios.post(dUrl.urlGlobal +'/api2/delete/', {
            table: 'logubica', 
            filters: { almacen: almacen.value, area: area.value, anaquel: anaquel.value, cara: cara.value, fila: fila.value, columna: columna.value
             }, // Filtro para identificar el registro a eliminar
        })
        console.log(response.data)
        emits("delLuProps", !props.btnLuDl)
    } catch (error) {
        console.error("Error actualizando datos:", error)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, "¿Estás seguro de querer eliminar el registro " + _toDisplayString((_unref(almacen), _unref(area), _unref(anaquel), _unref(cara), _unref(fila), _unref(columna))) + "?", 1),
        _hoisted_6
      ]),
      _hoisted_7,
      _createElementVNode("div", { class: "group-btn" }, [
        _createElementVNode("button", {
          class: "btn btn-secondary me-2",
          type: "button",
          style: {"background-color":"#24292F"},
          onClick: handleClick
        }, "Cancelar"),
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "button",
          style: {"background-color":"#001982"},
          onClick: handleSubmit
        }, "Eliminar")
      ])
    ])
  ], 64))
}
}

})